import { injectable } from 'inversify';
import { MultipartUploadAdapter } from '@dealroadshow/file-uploader';
import urls from '@allocate/config/allocateUrl';
import { IUploadAdapter } from './DI/interfaces';

@injectable()
export default class UploadAdapter extends MultipartUploadAdapter implements IUploadAdapter {
  constructor() {
    super({ url: urls.getBaseFilesUrl() });
  }
}
